<div class="delete-user-dialog">
    <div class="dialog-header">
        <div class="icon-container">
            <i class="ri-error-warning-line"></i>
        </div>
        <h2 mat-dialog-title>Confirmar Eliminación</h2>
    </div>

    <mat-dialog-content class="mat-typography">
        <div class="content">
            <p class="warning-text">
                ¿Está seguro que desea eliminar al usuario <strong>{{ getUserFullName() }}</strong>?
            </p>
            
            <div class="user-info">
                <div class="info-row">
                    <span class="label">Email:</span>
                    <span class="value">{{ data.user.email }}</span>
                </div>
                <div class="info-row">
                    <span class="label">Rol:</span>
                    <span class="value">{{ data.user.role }}</span>
                </div>
                <div class="info-row">
                    <span class="label">Estado:</span>
                    <span class="value" [class.active]="data.user.is_active" [class.inactive]="!data.user.is_active">
                        {{ data.user.is_active ? 'Activo' : 'Inactivo' }}
                    </span>
                </div>
                
                <!-- Información del cliente para usuarios con rol de cliente -->
                <div class="info-row" *ngIf="shouldShowClientInfo()">
                    <span class="label">Cliente:</span>
                    <span class="value">
                        <ng-container *ngIf="isLoadingClient">
                            <i class="ri-loader-4-line animate-spin me-2"></i>
                            Cargando...
                        </ng-container>
                        <ng-container *ngIf="!isLoadingClient && clientInfo">
                            {{ clientInfo.cliente }}
                        </ng-container>
                        <ng-container *ngIf="!isLoadingClient && clientError">
                            <span class="error-text">Error al cargar cliente</span>
                        </ng-container>
                    </span>
                </div>
            </div>

            <div class="warning-message">
                <i class="ri-alert-line"></i>
                <p>
                    <strong>Esta acción no se puede deshacer.</strong> 
                    El usuario será eliminado permanentemente del sistema.
                </p>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button type="button" mat-button (click)="onCancel()">
            <i class="ri-close-line me-2"></i>
            Cancelar
        </button>
        <button type="button" mat-raised-button color="warn" (click)="onConfirm()">
            <i class="ri-delete-bin-line me-2"></i>
            Eliminar Usuario
        </button>
    </mat-dialog-actions>
</div> 